import { Container, Drawer, LinearProgress } from '@mui/material';
import BulkActionsAppBar from 'layouts/Main/components/BulkActionsLedger/components/BulkActionsAppBar/BulkActionsAppBar';
import { BulkActionsContentWrapperProps } from './BulkActionsContentWrapper.props';

const BulkActionsContentWrapper = ({
  children,
  isLoading,
  open,
  onClose,
  appBarProps,
}: BulkActionsContentWrapperProps) => (
  <Drawer
    anchor="bottom"
    variant="temporary"
    slotProps={{
      paper: {
        style: {
          width: 'calc(100% - 60px)',
          top: `${document.querySelector('header')?.offsetHeight || 0}px`,
          left: '60px',
        },
      },
    }}
    open={open}
    onClose={onClose}>
    {isLoading && <LinearProgress color="primary" />}
    <BulkActionsAppBar {...appBarProps} />
    <Container maxWidth={false} sx={{ maxWidth: '1920px' }}>
      {children}
    </Container>
  </Drawer>
);

export default BulkActionsContentWrapper;
